var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock_FILL1_wght400_GRAD0_opsz24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.5 28C6.8125 28 6.22396 27.7552 5.73438 27.2656C5.24479 26.776 5 26.1875 5 25.5V13C5 12.3125 5.24479 11.724 5.73438 11.2344C6.22396 10.7448 6.8125 10.5 7.5 10.5H8.75V8C8.75 6.27083 9.35938 4.79688 10.5781 3.57812C11.7969 2.35938 13.2708 1.75 15 1.75C16.7292 1.75 18.2031 2.35938 19.4219 3.57812C20.6406 4.79688 21.25 6.27083 21.25 8V10.5H22.5C23.1875 10.5 23.776 10.7448 24.2656 11.2344C24.7552 11.724 25 12.3125 25 13V25.5C25 26.1875 24.7552 26.776 24.2656 27.2656C23.776 27.7552 23.1875 28 22.5 28H7.5ZM15 21.75C15.6875 21.75 16.276 21.5052 16.7656 21.0156C17.2552 20.526 17.5 19.9375 17.5 19.25C17.5 18.5625 17.2552 17.974 16.7656 17.4844C16.276 16.9948 15.6875 16.75 15 16.75C14.3125 16.75 13.724 16.9948 13.2344 17.4844C12.7448 17.974 12.5 18.5625 12.5 19.25C12.5 19.9375 12.7448 20.526 13.2344 21.0156C13.724 21.5052 14.3125 21.75 15 21.75ZM11.25 10.5H18.75V8C18.75 6.95833 18.3854 6.07292 17.6562 5.34375C16.9271 4.61458 16.0417 4.25 15 4.25C13.9583 4.25 13.0729 4.61458 12.3438 5.34375C11.6146 6.07292 11.25 6.95833 11.25 8V10.5Z",
    fill: "#0BA9E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.89c04641a86b7d5b11bee346524ddce5.svg";
export { ForwardRef as ReactComponent };